<div class="event-information pt-5">
  <!-- TODO: @Brennan - Add logo? -->
  <app-form-title [customClasses]="['mb-4']">Event Information</app-form-title>
  <app-form-subtitle [customClasses]="['text-left']">
    Additional Event information can be found <a [href]="setHrefUrl(event.event_website)" target="_blank">here</a>.
    Contact the <a href="mailto:{{eventOrganizer.profile_email}}">Event Organizer</a> or <a href="mailto:membership@usacycling.org">USA Cycling Membership Office</a> with any questions.
  </app-form-subtitle>
  <div class="row mt-4">
    <div class="col-sm-6 col-lg-4">
      <div>
        <h5>Event Name</h5>
        <p>{{event.event_name}}</p>
      </div>
      <div>
        <h5>Start Date</h5>
        <p>{{event.event_start_date | date:'fullDate'}}</p>
      </div>
      <div>
        <h5>End Date</h5>
        <p>{{event.event_end_date | date:'fullDate'}}</p>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4">
      <div>
        <h5>Event Organizer</h5>
        <p>{{eventOrganizer.profile_first_name}} {{eventOrganizer.profile_last_name}}</p>
      </div>
      <div>
        <h5>Website</h5>
        <p class="ellipsis-overflow">
          <a [href]="setHrefUrl(event.event_website)" target="_blank">
            {{event.event_website}}
          </a>
        </p>
      </div>
      <div *ngIf="event.event_announcement">
        <h5>Announcement</h5>
        <p class="ellipsis-overflow">
          <a [href]="setHrefUrl(event.event_announcement)" target="_blank">
            Event Announcement
          </a>
        </p>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4">
      <div *ngIf="event.event_reg_url">
        <h5>Main Registration Link</h5>
        <p class="ellipsis-overflow">
          <a [href]="setHrefUrl(event.event_reg_url)" target="_blank">
            {{event.event_reg_url}}
          </a>
        </p>
      </div>
      <div>
        <h5 *ngIf="hasSocialMedia">Social Media</h5>
        <p class="ellipsis-overflow">
          <span *ngIf="event.event_facebook_url">
            <a [href]="setHrefUrl(event.event_facebook_url)" target="_blank">{{event.event_facebook_url}}</a>
            <br />
          </span>
          <span *ngIf="event.event_twitter_url">
            <a [href]="setHrefUrl(event.event_twitter_url)" target="_blank">{{event.event_twitter_url}}</a>
            <br />
          </span>
          <span *ngIf="event.event_instagram_url">
            <a [href]="setHrefUrl(event.event_instagram_url)" target="_blank">{{event.event_instagram_url}}</a>
            <br />
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
